import { Link } from "gatsby"
import React from "react"
import WhiteLogo from '../components/LogoWhite'

const Header = () => {
  return(
      <React.Fragment>
         <footer className="footer">
            <div className="container">
                <div className="row">
                   <div className="col-md-3">
                      <Link to="/"><WhiteLogo /></Link>
                   </div>  
                   <div className="col-md-5">
                      <ul className="contactList">
                        <li><a href="mailto:info@trymocktest.com"><i className="ti-email"></i> info@trymocktest.com</a></li>  
                        <li><a href="tel:813-567-0088"><i className="ti-mobile"></i> 813-567-0088</a></li>  
                      </ul>
                   </div>  
                   <div className="col-md-4">
                    <ul className="socialList">
                        <li className="list-inline-item">
                          <p>Follow Us Online</p>
                        </li> 
                        <li className="list-inline-item">
                        <Link to="#/" className="square"><span className="ti-facebook"></span></Link>
                        </li>
                        <li className="list-inline-item"> <Link to="#/" className="square"><span className="ti-instagram"></span></Link>
                        </li>
                        <li className="list-inline-item"> <Link to="#/" className="square"><span className="ti-linkedin"></span></Link>
                        </li> 
                    </ul>
                   </div>  
                </div>
                <div className="credits">
                  <p>Copyright (c) 2020 TryMockTest.com. All rights reserved. </p>
                  <ul>
                     <li><Link to="/privacy-policy/">Privacy Policy</Link> </li>
                     <li><Link to="/terms-of-use/">Terms of Use</Link></li> 
                  </ul>
                </div>   
            </div>
        </footer>
      </React.Fragment>
  )
}


export default Header
